import account from './account'
import sidebar from './sidebar'

export default { account, sidebar }